'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	(0, _jquery2.default)('.popup-youtube', this).each(function () {
		(0, _jquery2.default)(this).magnificPopup({
			type: 'iframe' //,
			//iframe: {
			//	markup: '<div class="mfp-iframe-scaler">'+
			//			  '<div class="mfp-close"></div>'+
			//			  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
			//			'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

			//	patterns: {
			//		youtube: {
			//			index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

			//			id: 'v=', // String that splits URL in a two parts, second part should be %id%
			//			// Or null - full URL will be returned
			//			// Or a function that should return %id%, for example:
			//			// id: function(url) { return 'parsed id'; }

			//			src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
			//		}
			//	},

			//	srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
			//}
		});
	});

	(0, _jquery2.default)(".open-model-popup").magnificPopup({
		type: 'inline',
		midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	});
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import L from "linksoft/utils/localize"
var productRatingService = abp.services.api.productRating;

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/magnificPopup.js
// module id = 1072
// module chunks = 0